module.exports = __webpack_public_path__ + "assets/img/12e83e304897e1544558d54a24d5be77.png";